// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"I0-z"};